import {ModalSubNav} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {SubTab} from './CreateBuyerTabContent';
import type {FC} from 'react';

export interface CreateBuyerStepsNavProps {
  activeSubTab: SubTab;
  onSubTabChange: (tab: SubTab) => void;
  isBuyerFormValid: boolean;
}

export const CreateBuyerStepsNav: FC<CreateBuyerStepsNavProps> = ({
  activeSubTab,
  onSubTabChange,
  isBuyerFormValid
}) => {
  const {t} = useTranslation('trustAccounts');

  const items = [
    {
      value: 'buyer-details',
      label: t('view.buyers.addBuyerModal.subTabs.buyerDetails')
    },
    {
      value: 'fatca-crs',
      label: t('view.buyers.addBuyerModal.subTabs.fatcaCrs'),
      disabled: !isBuyerFormValid
    }
  ];

  return (
    <ModalSubNav items={items} value={activeSubTab} onChange={v => onSubTabChange(v as SubTab)} />
  );
};
